import * as Actions from '../../actions/superuser'

const initialState={
    data: [],
    selected: {
        data: null,
        isLoading: false,
        isLoaded: false,
        error: false
    },
    isLoading: false,
    isLoaded: false,
    error: false
}

const superusers=function(state=initialState,action) {
    switch(action.type) {
        case Actions.GET_SUPERUSERS: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: false
            }
        }
        case Actions.GET_SUPERUSERS_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                isLoaded: true,
                error: false
            }
        }
        case Actions.GET_SUPERUSERS_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                error: action.error
            }
        }

        case Actions.ADD_SUPERUSER: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: false
            }
        }
        case Actions.ADD_SUPERUSER_SUCCESS: {
            return {
                ...state,
                data: [...state.data,action.payload],
                isLoading: false,
                isLoaded: true,
                error: false
            }
        }
        case Actions.ADD_SUPERUSER_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                error: action.error
            }
        }


        case Actions.SELECT_SUPERUSER: {
            return {
                ...state,
                selected: {
                    isLoading: true,
                    isLoaded: false,
                    error: false
                }
            }
        }
        case Actions.SELECT_SUPERUSER_SUCCESS: {
            return {
                ...state,
                selected: {
                    data: action.payload,
                    isLoading: false,
                    isLoaded: true,
                    error: false
                },

            }
        }
        case Actions.SELECT_SUPERUSER_ERROR: {
            return {
                ...state,
                selected: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error
                }
            }
        }


        case Actions.UPDATE_SUPERUSER: {
            return {
                ...state,
                isLoading: true,
                isUpdated: false,
                error: false
            };
        }
        case Actions.UPDATE_SUPERUSER_SUCCESS: {
            let newData=state.data
            let superUserIndex=newData.findIndex(su => su._id===action.payload._id)
            newData[superUserIndex] = action.payload

            return {
                ...state,
                data: newData,
                isLoading: false,
                isUpdated: true,
                error: false
            };
        }
        case Actions.UPDATE_SUPERUSER_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                isUpdated: false,
                error: action.error
            };
        }

        default: {
            return state
        }
    }
}

export default superusers